const defaultTemplate = {};

export default defaultTemplate;
